<template>
   <div class="dashboard-content-container">
    <div class="dashboard-content-inner">
      <div class="dashboard-headline">
        <h3>Running Jobs</h3>

        <!-- Breadcrumbs -->
        <nav id="breadcrumbs" class="dark">
          <ul>
            <li><a href="#">Home</a></li>
            <li><a href="#">Dashboard</a></li>
            <li>Running Jobs</li>
          </ul>
        </nav>
      </div>

      <table class="table table-striped table-hover">
        <caption>
          List of running jobs
        </caption>
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Project Title</th>
            <th scope="col">Date Created</th>
            <th scope="col"></th>
          </tr>
        </thead>
         <tr v-if="projects.length == 0">You currently do not have any running jobs</tr>
        <tbody v-else>
         
          <tr v-for="(project, index) in projects" :key="project.id" >
            <th scope="row">{{ index + 1 }}</th>
            <td>{{ project.title }}</td>
            <td>{{ project.created_at.slice(0, 10) }}</td>
            <td>
              <modal 
              @clicked="showModal(index)" 
              :id="index" 
              :toggled="dropdownToggle" 
              :amountpaid="project.amount_paid | addCommaToAmount" 
              @pay="makePayment($event)"
              v-model="amount"
              :project_id="project.id"
              />
            </td>
            <td>
              <router-link :to="`/dashboard/jobs/viewproject/${project.id}`" @click="disableEdit">
              View Project
              </router-link>
            
            </td>
            
          </tr>
         
        </tbody>
      </table>
    </div>
     
  </div>
 
</template>


<script>
  /* eslint-disable no-console */
  import { MY_RUNNING_PROJECTS } from '../../../core/config/endpoints/projects';
  import { getCall } from '../../../core/services/http.service';
  
  export default {
    name: 'RunnigProjects',
    components: {},
    data() {
      return {
        projects:[],
        isEmpty: false
      };
    },
    created(){
      this.myRunningProjects
    },
    methods: {
      myRunningProjects() {
        this.$store.commit('setIsLoaded', true);
        getCall(MY_RUNNING_PROJECTS)
          .then((response) => {
            if(response.status == 200){
              this.projects = response.data
            }
          })
          .catch((error) => {
            this.$toast.error(`${error.response.data.message}`);
          })
          .finally(() => {
            this.$store.commit('setIsLoaded', false);
          });
      },
    },
  };
</script>

<style></style>
